import React, { Component, Fragment } from 'react';
import { Modal, List, Table } from 'antd';
import './logistics.less';
export default class LogisticsModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fakeData: []
    };
  }
  fakeData = [
    {
      goods_info: [{}],
      track_no: '',
      track_time: '',
      vehicle_info: []
    }
  ]
  columns = [
    {
      title: "司机",
      align: "center",
      dataIndex: "driver",
    },
    {
      title: "电话",
      align: "center",
      dataIndex: "mobile",
    },
    {
      title: "车型",
      align: "center",
      dataIndex: "model",
    },
    {
      title: "货箱温度",
      align: "center",
      dataIndex: "temperature",
    },
    {
      title: "车辆状态",
      align: "center",
      dataIndex: "track_status",
    },
    {
      title: "车辆位置",
      align: "center",
      dataIndex: "location",
    },
  ]
  componentDidMount() {
  }
  componentWillUnmount() {
    this.setState = () => false;
  }
  render() {
    const { visible, oncancel, logisticsData, orderStatus } = this.props;
    return (
      <div >
        <Modal
          open={visible}
          width={960}
          closable={true}
          onCancel={oncancel}
          bodyStyle={{ padding: 0 }}
          footer={false}
        >
          <List
            pagination={logisticsData.length > 0 ? { pageSize: 1 } : false}
            className="purchaseDetail"
            dataSource={logisticsData.length > 0 ? logisticsData : this.fakeData}
            title="物流详情"
            renderItem={item => (
              <List.Item
                key={item.track_no}
              >
                <ul className="purchaseDetailTop">
                  <li >运输订单号：{item.track_no}</li>
                  <li >订单状态：{orderStatus === 1 ? '待收货' : '已完成'}</li>
                  <li>更新时间：{item.track_time}</li>
                </ul>
                <Table
                  rowKey={record => record.model}
                  dataSource={logisticsData.length > 0 ? [item.vehicle_info] : item.vehicle_info}
                  columns={this.columns}
                  bordered
                  pagination={false}
                  className="purchaseTable"
                  locale={{ emptyText: '抱歉！没有获取到物流信息' }}
                />
                {

                  logisticsData.length > 0 ?
                    <Fragment>
                      <div className="purchaseDetailCenter"><p>装货信息</p></div>
                      <div style={{ 'overflow-y': 'scroll', 'height': '300px' }}>
                        {item.goods_info.map((value, index) => {
                          return <div key={index} className="purchaseDetailConWrap">
                            <div key={value.sku_name} className="purchaseDetailContent">
                              <div className=""> <div className="centerLeft">{value.sku_name}</div></div>
                              <div className="centerRight">共计{value.sku_number}件</div>
                            </div>
                          </div>;
                        })}
                      </div>
                    </Fragment> : null
                }
              </List.Item>

            )}
          />
        </Modal>
      </div>
    );
  }
}

